import * as React from 'react'

import Svg, {
  G,
  Mask,
  Path,
  Defs,
  RadialGradient,
  Stop,
  ClipPath,
} from 'react-native-svg'

const EligibilityCreteria = ({ ...props }) => {
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_4356_256)">
        <Mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={48}
          height={48}
        >
          <Path
            d="M40 0H8a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V8a8 8 0 00-8-8z"
            fill="#fff"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M40 0H8a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V8a8 8 0 00-8-8z"
            fill="#F2F7FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.099 24.74c-1.106-.413-2.144-.812-3.005-1.144l-1.056-.406a2.924 2.924 0 00-2.076 0l-1.057.406c-2.982 1.149-8.088 3.115-10.76 3.632-.668.13-1.145.687-1.145 1.329v8.23c0 6.452 3.088 12.563 8.409 16.635l1.642 1.257c2.3 1.761 5.598 1.761 7.899 0l1.642-1.257C33.912 49.35 37 43.24 37 36.786v-2.848a8 8 0 01-8.901-9.197z"
            fill="url(#paint0_radial_4356_256)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 26.201A6.204 6.204 0 0136.201 20a6.196 6.196 0 016.201 6.201 6.2 6.2 0 01-6.2 6.201 6.204 6.204 0 01-6.202-6.2zm8.434-2.919a1.127 1.127 0 011.6 1.587l-4.244 4.245c-.44.44-1.154.44-1.594 0l-1.81-1.81a1.127 1.127 0 011.594-1.594l1.013 1.014 3.441-3.442z"
            fill="url(#paint1_radial_4356_256)"
          />
          <Path
            d="M33 39.49c0 2.876-1.336 5.455-3.448 7.203-1.755 1.453-4.046 1.443-6.552 1.443-2.481 0-4.751.027-6.499-1.4C14.358 44.989 13 42.39 13 39.49c0-5.266 4.477-9.535 10-9.535s10 4.269 10 9.535z"
            fill="#D8E3FD"
          />
          <Path
            d="M23 42a3 3 0 100-6 3 3 0 000 6z"
            fill="url(#paint2_radial_4356_256)"
          />
          <Path
            d="M29.003 44.404c1.223.626 1.344 2.022.236 2.772l-.038.026C27.527 48.325 25.367 49 23.01 49c-2.38 0-4.559-.69-6.24-1.831l-.02-.014c-1.1-.751-.97-2.145.252-2.767C18.732 43.51 20.785 43 22.987 43c2.216 0 4.28.515 6.016 1.404z"
            fill="url(#paint3_radial_4356_256)"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_4356_256"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(128.347 11.35 21.012) scale(38.1072 34.4865)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_4356_256"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(133.167 15.73 19.127) scale(15.9379 13.8913)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_4356_256"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(132.995 4.86 23.75) scale(7.42927 6.89193)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_4356_256"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-11.82147 5.43377 -3.83511 -8.3435 28.935 43.39)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <ClipPath id="clip0_4356_256">
          <Path fill="#fff" d="M0 0H48V48H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default EligibilityCreteria
